<template>
  <div class="project">
    <div class="project-content">
      <div v-if="infos.embededCover">
        <div class="project-cover has-cascade-animation" v-html="infos.embededCover"></div>
      </div>
      <div v-else-if="infos.cover">
        <img class="project-cover has-cascade-animation" v-if="!isVideo(infos.cover)" :src="require(`@/assets/${$route.params.id}/${infos.cover}`)">
        <video class="project-cover has-cascade-animation" v-if="isVideo(infos.cover)" :src="require(`@/assets/${$route.params.id}/${infos.cover}`)" autoplay loop playsinline muted></video>
      </div>
      <h1 class="project-title has-cascade-animation">{{ infos.title }}</h1>
      <h2 class="project-subtitle has-cascade-animation">{{ infos.subtitle }}</h2>
      <div class="project-infos">
        <h5 class="project-client has-cascade-animation">{{ infos.client }}</h5>
        <p class="project-place-date has-cascade-animation">{{ infos.date }} @ {{ infos.place }}</p>
        <ul class="project-keywords has-cascade-animation">
          <li v-for="keyword in infos.keywords">{{ keyword }}</li>
        </ul>
        <p class="project-details has-cascade-animation" v-html="details"></p>
        <p class="project-tech has-cascade-animation">tech used: {{ infos.tech }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, Power4 } from 'gsap'

export default {
  name: 'project',
  data () {
    let infos = {}
    let details = {}

    try {
      infos = require(`@/assets/${this.$route.params.id}/infos`)
      details = require(`@/assets/${this.$route.params.id}/details.txt`).default
    } catch (ignore) {
      this.$nextTick(() => {
        this.$router.push('/')
      })
    }

    return {
      infos,
      details
    }
  },
  metaInfo () {
    return {
      title: `hugohil — ${this.infos.title}`,
      meta: [
        { name: 'description', content: this.infos.subtitle }
      ]
    }
  },
  mounted () {
    this.animateEnter()
  },
  beforeRouteUpdate (to, from, next) {
    this.animateLeave(() => {
      try {
        this.infos = require(`@/assets/${to.params.id}/infos`)
        this.details = require(`@/assets/${to.params.id}/details.txt`).default
        this.animateEnter()
        next()
      } catch (ignore) {
        next('/')
      }
    })
  },
  beforeRouteLeave (to, from, next) {
    this.animateLeave(next)
  },
  methods: {
    animateEnter () {
      this.$nextTick(() => {
        TweenMax.staggerFromTo('.has-cascade-animation', 0.3, {
          y: -10,
          opacity: 0
        }, {
          y: 0,
          opacity: 1,
          delay: 0.5,
          ease: Power4.Out
        }, 0.1)
      })
    },
    animateLeave (next) {
      TweenMax.to('#main', 0.3, {
        scrollTop: 0,
        ease: Power4.In,
        onComplete () {
          TweenMax.staggerFromTo('.has-cascade-animation', 0.2, {
            y: 0,
            opacity: 1
          }, {
            y: -10,
            opacity: 0,
            ease: Power4.Out
          }, 0.05, () => { next() })
        }
      })
    },
    isVideo (media) {
      return /\.(mp4|webm)$/i.test(media)
    },
    isEmbeded (media) {
      return /<iframe>/i.test(media)
    }
  }
}
</script>

<style lang="scss">
  .project {
    padding: 0 2em;
    margin: 3em 0;
    max-width: 960px;
  }

  .project-cover {
    width: 100%;
  }

  .project-cover, img, video, iframe {
    max-width: 960px;
  }

  .project-title {
    line-height: 1.2em;
    margin: .2em 0;
  }
  .project-subtitle {
    margin: .2em 0;
  }
  .project-client {
    font-weight: 300;
    line-height: 1.5em;
  }
  .project-place-date {
    font-style: italic;
    font-weight: 300;
    line-height: 1.5em;
  }
  .project-keywords {
    li {
      line-height: 1.5em;
      display: inline-block;
      font-style: italic;
      font-weight: 200;
      font-size: 14px;

      &:after {
        content: '*';
        margin: 0 .5em;
        font-weight: 300;
      }
      &:last-child:after {
        display: none;
      }
    }
  }
  .project-details {
    margin: 1em 0;
    line-height: 1.5em;
    font-weight: 400;
    font-size: 14px;

    &:before {
      content: '***';
      margin-right: .5em;
      font-weight: 600;
    }
  }
  .project-tech {
    font-style: italic;
    line-height: 1.5em;
    font-weight: 200;
    font-size: 12px;
  }

  @media (max-width: 1620px) {
    img, video, iframe {
      max-width: 100%;
    }
  }

  @media (max-width: 960px) {
    .project {
      padding: 0 .5em;
    }
    .project-title {
      font-size: 38px;
      overflow-wrap: break-word;
    }
    .project-subtitle {
      font-size: 24px;
    }
    .project-cover, img, video, iframe {
      width: 100%;
      height: auto;
    }
  }
</style>
